module.exports = __webpack_public_path__ + "static/img/10.72e746c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/en/10.jpg
// module id = NXE4
// module chunks = 2